import { OrderItem, OrderItemType } from 'types/pwcOrder';

import { OrderItemComponent } from './components/orderItem/orderItem';
import { KEYS } from './keys';

export enum OrderListType {
  Items = 'items',
  Fees = 'fees',
}

interface getListOfItemsProps {
  items?: OrderItem[];
  listType: OrderListType;
  fiatCurrencyCode: string | null;
}

export const getListOfItems = ({ items, listType, fiatCurrencyCode }: getListOfItemsProps) => {
  if (!items || items.length === 0) {
    return [];
  }
  const { products, fees } = categorizeAndSortItems(items);

  const orderItems = products.map((item, index) => getItem(item, index, fiatCurrencyCode || KEYS.FALLBACK_FIAT_CURRENCY_CODE));
  const orderFees = fees.map((item, index) => getItem(item, index, fiatCurrencyCode || KEYS.FALLBACK_FIAT_CURRENCY_CODE));

  if (listType === OrderListType.Items) {
    return orderItems;
  }

  if (listType === OrderListType.Fees) {
    return orderFees;
  }

  return [...orderItems, ...orderFees];
};

const categorizeAndSortItems = (items: (OrderItem | null)[]): { products: OrderItem[]; fees: OrderItem[] } => {
  const sortPriorityMap: Record<string, number> = {
    [OrderItemType.Custom]: 0,
    [OrderItemType.Gratuity]: 1,
    [OrderItemType.Delivery]: 2,
    [OrderItemType.Tax]: 3,
    [OrderItemType.Tip]: 4,
    [OrderItemType.Discount]: 5,
    [OrderItemType.ProcessingFee]: 6,
  };

  const categorizedItems = items.reduce<{ products: OrderItem[]; fees: OrderItem[] }>(
    (acc, item) => {
      if (!item) return acc;
      if (item.type === OrderItemType.Product) {
        acc.products.push(item);
      } else {
        acc.fees.push(item);
      }
      return acc;
    },
    { products: [], fees: [] },
  );

  categorizedItems.fees.sort((a, b) => sortPriorityMap[a.type] - sortPriorityMap[b.type]);

  return categorizedItems;
};

const getItem = (item: OrderItem | null, index: number, fiatCurrencyCode: string) =>
  item ? <OrderItemComponent key={item.uuid} fiatCurrencyCode={fiatCurrencyCode} orderItem={item} index={index} /> : null;
